















import {
  Vue, Component, Mixins, Prop,
} from 'vue-property-decorator';

import MyCommon from '@/mixins/common';

import LineChart from './charts/line-chart.vue';

@Component({
  components: {
    LineChart,
  },
})
export default class extends Mixins(MyCommon) {
  @Prop() params!: any;
}
